 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSHT from '@/components/OEBPS/ht'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTITLE from '@/components/OEBPS/title'
 import OEBPSNOTICE from '@/components/OEBPS/notice'
 import OEBPSMINI_TOC from '@/components/OEBPS/mini_toc'
 import OEBPSDEDICATION from '@/components/OEBPS/dedication'
 import OEBPSDRAMATIS from '@/components/OEBPS/dramatis'
 import OEBPSINTRODUCTION from '@/components/OEBPS/introduction'
 import OEBPSPART01 from '@/components/OEBPS/part01'
 import OEBPSCHAPTER001 from '@/components/OEBPS/chapter001'
 import OEBPSCHAPTER002 from '@/components/OEBPS/chapter002'
 import OEBPSCHAPTER003 from '@/components/OEBPS/chapter003'
 import OEBPSCHAPTER004 from '@/components/OEBPS/chapter004'
 import OEBPSCHAPTER005 from '@/components/OEBPS/chapter005'
 import OEBPSCHAPTER006 from '@/components/OEBPS/chapter006'
 import OEBPSPART02 from '@/components/OEBPS/part02'
 import OEBPSCHAPTER007 from '@/components/OEBPS/chapter007'
 import OEBPSCHAPTER008 from '@/components/OEBPS/chapter008'
 import OEBPSCHAPTER009 from '@/components/OEBPS/chapter009'
 import OEBPSCHAPTER010 from '@/components/OEBPS/chapter010'
 import OEBPSCHAPTER011 from '@/components/OEBPS/chapter011'
 import OEBPSCHAPTER012 from '@/components/OEBPS/chapter012'
 import OEBPSCHAPTER013 from '@/components/OEBPS/chapter013'
 import OEBPSCHAPTER014 from '@/components/OEBPS/chapter014'
 import OEBPSCHAPTER015 from '@/components/OEBPS/chapter015'
 import OEBPSCHAPTER016 from '@/components/OEBPS/chapter016'
 import OEBPSPART03 from '@/components/OEBPS/part03'
 import OEBPSCHAPTER017 from '@/components/OEBPS/chapter017'
 import OEBPSCHAPTER018 from '@/components/OEBPS/chapter018'
 import OEBPSCHAPTER019 from '@/components/OEBPS/chapter019'
 import OEBPSCHAPTER020 from '@/components/OEBPS/chapter020'
 import OEBPSCHAPTER021 from '@/components/OEBPS/chapter021'
 import OEBPSCHAPTER022 from '@/components/OEBPS/chapter022'
 import OEBPSCHAPTER023 from '@/components/OEBPS/chapter023'
 import OEBPSPART04 from '@/components/OEBPS/part04'
 import OEBPSCHAPTER024 from '@/components/OEBPS/chapter024'
 import OEBPSCHAPTER025 from '@/components/OEBPS/chapter025'
 import OEBPSCHAPTER026 from '@/components/OEBPS/chapter026'
 import OEBPSCHAPTER027 from '@/components/OEBPS/chapter027'
 import OEBPSCHAPTER028 from '@/components/OEBPS/chapter028'
 import OEBPSCHAPTER029 from '@/components/OEBPS/chapter029'
 import OEBPSCHAPTER030 from '@/components/OEBPS/chapter030'
 import OEBPSEPI from '@/components/OEBPS/epi'
 import LOVE_2 from '@/components/love_2'
 import OEBPSNOTE from '@/components/OEBPS/note'
 import OEBPSBIBLIO from '@/components/OEBPS/biblio'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSINDIX from '@/components/OEBPS/indix'
 import OEBPSATA from '@/components/OEBPS/ata'
 import OEBPSNEWSLETTER from '@/components/OEBPS/newsletter'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSCOPYRIGHT from '@/components/OEBPS/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/ht",
 			"name" : "OEBPS/ht",
 			"component" : OEBPSHT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/title",
 			"name" : "OEBPS/title",
 			"component" : OEBPSTITLE
 		},
 		{
 			"path" : "/OEBPS/notice",
 			"name" : "OEBPS/notice",
 			"component" : OEBPSNOTICE
 		},
 		{
 			"path" : "/OEBPS/mini_toc",
 			"name" : "OEBPS/mini_toc",
 			"component" : OEBPSMINI_TOC
 		},
 		{
 			"path" : "/OEBPS/dedication",
 			"name" : "OEBPS/dedication",
 			"component" : OEBPSDEDICATION
 		},
 		{
 			"path" : "/OEBPS/dramatis",
 			"name" : "OEBPS/dramatis",
 			"component" : OEBPSDRAMATIS
 		},
 		{
 			"path" : "/OEBPS/introduction",
 			"name" : "OEBPS/introduction",
 			"component" : OEBPSINTRODUCTION
 		},
 		{
 			"path" : "/OEBPS/part01",
 			"name" : "OEBPS/part01",
 			"component" : OEBPSPART01
 		},
 		{
 			"path" : "/OEBPS/chapter001",
 			"name" : "OEBPS/chapter001",
 			"component" : OEBPSCHAPTER001
 		},
 		{
 			"path" : "/OEBPS/chapter002",
 			"name" : "OEBPS/chapter002",
 			"component" : OEBPSCHAPTER002
 		},
 		{
 			"path" : "/OEBPS/chapter003",
 			"name" : "OEBPS/chapter003",
 			"component" : OEBPSCHAPTER003
 		},
 		{
 			"path" : "/OEBPS/chapter004",
 			"name" : "OEBPS/chapter004",
 			"component" : OEBPSCHAPTER004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js